import './index.css';

import React, {useEffect, useState, useCallback} from 'react';

import {
  $getRoot,
  $getSelection,
  FORMAT_ELEMENT_COMMAND,
  FORMAT_TEXT_COMMAND,
  SELECTION_CHANGE_COMMAND
} from 'lexical';
import {LexicalComposer} from '@lexical/react/LexicalComposer';
import {RichTextPlugin} from '@lexical/react/LexicalRichTextPlugin';
import {ContentEditable} from '@lexical/react/LexicalContentEditable';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary';
import {mergeRegister} from '@lexical/utils';
import {
  EditorPlaceholder,
  EditorToolbarButton,
  EditorToolbarButtonSpacer,
  EditorToolbarContainer,
  InnerInputContainer,
  Input,
  InputContainer,
  Label
} from './styles';

const theme = {
  text: {
    bold: "editor-text-bold",
    italic: "editor-text-italic",
    underline: "editor-text-underline",
  }
}

// When the editor changes, you can get notified via the
// LexicalOnChangePlugin!
function onChange(editorState) {
  editorState.read(() => {
    // Read the contents of the EditorState here.
    const root = $getRoot();
    const selection = $getSelection();

    console.log(root, selection);
  });
}

// Lexical React plugins are React components, which makes them
// highly composable. Furthermore, you can lazy load plugins if
// desired, so you don't pay the cost for plugins until you
// actually use them.
function MyCustomAutoFocusPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    // Focus the editor when the effect fires!
    editor.focus();
  }, [editor]);

  return null;
}

// Catch any errors that occur during Lexical updates and log them
// or throw them as needed. If you don't throw them, Lexical will
// try to recover gracefully without losing user data.
function onError(error) {
  console.error(error);
}

function EditorToolbarPlugin() {
  const [editor] = useLexicalComposerContext();
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [isUndeline, setIsUnderline] = useState(false);

  const onUpdateToolbar = useCallback(() => {
    const selection = $getSelection();

    setIsBold(selection.hasFormat("bold"));
    setIsItalic(selection.hasFormat("italic"));
    setIsUnderline(selection.hasFormat("underline"));
  }, [editor]);

  useEffect(() => {
    return mergeRegister(
      editor.registerUpdateListener(({editorState}) => {
        editorState.read(() => {
          onUpdateToolbar();
        })
      })
    )
  }, [editor, onUpdateToolbar]);

  return (
    <EditorToolbarContainer>
      <EditorToolbarButton isSelected={isBold} onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold')}>B</EditorToolbarButton>
      <EditorToolbarButtonSpacer />
      <EditorToolbarButton isSelected={isItalic} onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic')}><i>I</i></EditorToolbarButton>
      <EditorToolbarButtonSpacer />
      <EditorToolbarButton isSelected={isUndeline} onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline')}><u>U</u></EditorToolbarButton>
    </EditorToolbarContainer>
  );
}

export function TextEditor({
  label = 'Label'
}) {
  const initialConfig = {
    namespace: 'TextEditor', 
    theme,
    onError,
  };

  return (
    <LexicalComposer initialConfig={initialConfig}>
      <Label>{label}</Label>
      <InputContainer>
        <EditorToolbarPlugin />
        <InnerInputContainer>
          <RichTextPlugin
            contentEditable={<Input />}
            placeholder={<EditorPlaceholder>Enter some text...</EditorPlaceholder>}
            ErrorBoundary={LexicalErrorBoundary}
          />
        </InnerInputContainer>
      </InputContainer>
    </LexicalComposer>
  );
}